module.exports = __webpack_public_path__ + "eb9d1fb598a324217f3d02ae8ab02abf.png";